import { svgIcons } from "./svgIcons";


type AddIconProps = {
    mode: number,
    onAddHandler: any,
    addBtnLeft: boolean,
}

const addIcon = ({ mode, onAddHandler, addBtnLeft}: AddIconProps) => {;
return <div className={!addBtnLeft ? "fixed bottom-[10px] left-0 p-4 md:hidden" : "fixed bottom-[10px] right-0 p-4 md:hidden"}>
<span
  className={
    mode === 1
      ? "drop-shadow-none fill-white/50"
      : "hover:drop-shadow-sm fill-[#C84B31] hover:fill-[#C84B31]/80"
  }
  onClick={onAddHandler}
>
  {svgIcons.addIcon}
</span>
</div>
};

export default addIcon;